//NOTE: this file is AUTO GENERATED. DO NOT MANUALLY EDIT OR COMMIT
    /* tslint:disable */
    export const VERSION = {
    "dirty": false,
    "raw": "8b3737c",
    "hash": "8b3737c",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "8b3737c",
    "semverString": null,
    "version": "0.0.0"
};
    export const BUILD_DATE = "Mon Jun 30 2025 11:06:13 GMT+0000 (Coordinated Universal Time)";
    /* tslint:enable */
    